@if (state === 'loading') {
  <app-spinner></app-spinner>
}
@if (state === 'not-found') {
  <tyt-not-found
    [checkRedirect]="false" [checkForUpdates]="false"
    message="We couldn't find the article you wanted to read."
  ></tyt-not-found>
}
@if (state === 'ready') {
  <tyt-article [article]="article" [allowEditor]="true"></tyt-article>
  @if (article && (!article.franchise || !article.franchise.is_branded_content)) {
    <tyt-comments
      [url]="url"
      [identifier]="topicIdentifier"
      [requirementType]="article?.franchise?.public_comment_allowed ? 'registration' : 'membership'"
      >
    </tyt-comments>
  }
}